import { render, staticRenderFns } from "./ReviewProgress.vue?vue&type=template&id=d1484d7a&scoped=true"
import script from "./ReviewProgress.vue?vue&type=script&lang=js"
export * from "./ReviewProgress.vue?vue&type=script&lang=js"
import style0 from "./ReviewProgress.vue?vue&type=style&index=0&id=d1484d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1484d7a",
  null
  
)

export default component.exports